import styled from 'styled-components';

const FontSize26H2 = styled.h2`
  color: #173c51;
  font-size: 26px;
  font-weight: 300;
`;

export default FontSize26H2;
